import axios from 'axios';
import { logger } from '@parrot-software/observability';

import type { ICashRegisterPort } from '@onboarding/application/ports';
import type { CashRegisterDto } from '@onboarding/application/dtos';
import { createCashRegisterConfig, CASH_REGISTER_TYPES } from '@onboarding/domain/value-objects';

const onbLog = logger.forDomain('ONB');

/**
 * Use case for applying cash register configuration.
 *
 * Flow: CashRegisterDto → domain value object (validated) → GET current config → merge → PUT via port
 *
 * @param props.cashRegisterPort - ICashRegisterPort implementation (injected)
 * @returns Use case executor
 */
export const applyCashRegisterUseCase = (props: { cashRegisterPort: ICashRegisterPort }) => {
  const { cashRegisterPort } = props;

  const execute = async (dto: CashRegisterDto): Promise<void> => {
    const cutType = dto.blindClosing ? CASH_REGISTER_TYPES.BLIND : CASH_REGISTER_TYPES.VISIBLE;

    try {
      const config = createCashRegisterConfig(cutType);
      await cashRegisterPort.applyCashRegisterConfig(config);
    } catch (error) {
      onbLog.error('cash_register_apply_failed', {
        'error.kind': (error as { constructor?: { name?: string } })?.constructor?.name ?? 'UnknownError',
        'error.message': error instanceof Error ? error.message : String(error),
        'http.status_code': axios.isAxiosError(error) ? error.response?.status : undefined,
        'onb.cut_type': cutType,
      });
      throw error;
    }
  };

  return { execute };
};
